import * as Sentry from '@sentry/browser';

export const reportToSentry = (unhandled, error, endpoint) => {
  const errorMessage = error.toJSON().message;
  const name = `[${endpoint}]: ${errorMessage}`;

  Sentry.captureException(error, scope => {
    scope.setFingerprint([endpoint]);
    scope.setTransactionName(name);
    scope.setLevel('error');
    scope.setExtra('Unhandled errors', unhandled);
  });
};